import React from "react";
import "./vision.css";

function Vision() {
  return (
    <div className="vision-wrapper">
      
      <h1 className="section-heading">Our Vision & Mission</h1>

      <div className="vision-container">
        {/* Vision Card */}
        <div className="vision-card">
          <h2 className="vision-title">Vision</h2>
          <ul>
            <li>Empowering businesses through innovative adhesive solutions</li>
            <li>Achieving operational excellence and sustainable growth</li>
            <li>Leading provider of reliable adhesive solutions</li>
            <li>Pioneering new technologies for a better & greater future</li>
            <li>Ensuring customer satisfaction through continuous improvement</li>
            <li>Fostering a culture of innovation and excellence</li>
          </ul>
        </div>

    
        <div className="vision-card">
          <h2 className="vision-title">Mission</h2>
          <ul>
            <li>Delivering cutting-edge adhesive solutions with precision</li>
            <li>Fostering long-lasting partnerships with clients</li>
            <li>Building a sustainable future through eco-friendly practices</li>
            <li>Embracing diversity and inclusion in all aspects of our business</li>
            <li>Striving for excellence in all our endeavors at top level</li>
            <li>Providing exceptional customer service and support</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Vision;
